import { z } from "zod";

import { BillingStatusUpdateInputSchema } from "@/lib/zod/__generated__/validation-schema";

import type { ZodError } from "zod";

/**
 *
 * @description 解約用のバリデーションスキーマ
 */
export const CancellationInputZodSchema = BillingStatusUpdateInputSchema.extend({
	churnInfo: z.object({
		comment: z.string().max(3000).nullish(),
		reason: z.string().min(1, "解約理由を1つ以上選択してください"),
		alternativeSystemProductName: z.string().nullish(),
		alternativeSystemReason: z.string().nullish(),
	}),
}).superRefine((data, ctx) => {
	// 解約理由に「他の予約システムへ乗り換え」が含まれている場合、製品名と理由を必須にする
	const reasonArray = data.churnInfo.reason.split(", ").filter((value) => value.trim().length > 0);
	const hasAlternativeSystemReason = reasonArray.includes("他の予約システムへ乗り換え");

	if (hasAlternativeSystemReason) {
		// 製品名のバリデーション
		const productName = data.churnInfo.alternativeSystemProductName;
		if (!productName || productName.trim().length === 0) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "製品名を入力してください",
				path: ["churnInfo", "alternativeSystemProductName"],
			});
		} else if (productName.length < 2) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "製品名は2文字以上で入力してください",
				path: ["churnInfo", "alternativeSystemProductName"],
			});
		} else if (productName.length > 100) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "製品名は100文字以内で入力してください",
				path: ["churnInfo", "alternativeSystemProductName"],
			});
		}

		// 理由のバリデーション
		const reason = data.churnInfo.alternativeSystemReason;
		if (!reason || reason.trim().length === 0) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "理由を入力してください",
				path: ["churnInfo", "alternativeSystemReason"],
			});
		} else if (reason.length < 2) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "理由は2文字以上で入力してください",
				path: ["churnInfo", "alternativeSystemReason"],
			});
		} else if (reason.length > 3000) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "理由は3000文字以内で入力してください",
				path: ["churnInfo", "alternativeSystemReason"],
			});
		}
	}
});

export type CancellationInputZodSchemaType = z.infer<typeof CancellationInputZodSchema>;

export type CancellationInputZodParseError = ZodError<CancellationInputZodSchemaType>;
